const template=`
<widget-status></widget-status>
<map-highchart data="mapSettings" maximized="isMaximized" data-ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"></map-highchart>`;
export default template;
